import React, { Fragment } from "react";

import "./styles.scss";

const MenuPopUp = (props) => {
  const { actions, position } = props;
  const styles = {
    left: position ? `${position.left}px` : "50%",
    top: position ? `${position.top}px` : "50%",
    transform: !position && "translate(-50%,-50%)",
  };
  const mobileStyles = {
    bottom: "0",
    left: "0",
  };

  const desktopView = (
    <div className="MenuPopUp position-fixed d-none d-lg-block" style={styles}>
      <ul>
        {Object.entries(actions).map(([action, options]) => {
          return (
            <li className="MenuPopUp__li my-3 px-3 cursor" key={action} onClick={options.handler}>
              {options.caption}
            </li>
          );
        })}
      </ul>
    </div>
  );

  const mobileView = (
    <div className="Status__Mobile-context-menu-wpr d-block d-lg-none position-fixed">
      <div className="Status__Mobile-context-menu position-absolute" style={mobileStyles}>
        {/* actions list */}
        <div className="Status__Mobile-context-menu-action-list-wpr">
          <ul className="px-4">
            {Object.entries(actions).map(([action, options]) => {
              return (
                <li className="py-3" key={action} onClick={options.handler}>
                  {options.caption}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      {desktopView}
      {mobileView}
    </Fragment>
  );
};

export default MenuPopUp;
